import axios from "axios";
import { getAuth } from "firebase/auth";

const API_BASE_URL =
  "https://europe-west3-hyper-e122e.cloudfunctions.net";

function authStateReady() {
  return new Promise((resolve) => {
    const auth = getAuth();

    if (auth.currentUser) {
      resolve(auth.currentUser);
      return;
    }

    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    });
  });
}

class VideoConferenceService {
  /**
   * Создать видеоконференцию Яндекс Телемост
   *
   * @param {string} chatId
   * @param {string} title
   * @returns {Promise<{
   *   success: boolean,
   *   messageId: string|null,
   *   chatId: string|null,
   *   conference: Object|null,
   *   pushSent: boolean,
   *   error?: string
   * }>}
   */
  static async createConference(
    chatId,
    title = "Видеозвонок"
  ) {
    console.log("📹 Создание видеоконференции...", {
      chatId,
      title,
    });

    try {
      if (!chatId) {
        throw new Error("chat_id обязателен");
      }

      const user = await authStateReady();

      if (!user) {
        throw new Error("Пользователь не авторизован");
      }

      const token = await user.getIdToken(true);

      const response = await axios.post(
        `${API_BASE_URL}/create_video_conference`,
        {
          chat_id: chatId,
          sender_id: user.uid,
          title: title || "Видеозвонок",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(
        "✅ Видеоконференция успешно создана:",
        response.data
      );

      return {
        success: response.data?.success === true,
        messageId:
          response.data?.message_id ??
          response.data?.messageId ??
          null,
        chatId:
          response.data?.chat_id ??
          response.data?.chatId ??
          chatId,
        conference: response.data?.conference ?? null,
        pushSent:
          response.data?.push_sent ??
          response.data?.pushSent ??
          false,
      };
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error ||
        error?.message ||
        "Не удалось создать видеоконференцию";

      console.error(
        "❌ Ошибка создания видеоконференции:",
        error?.response?.data || error
      );

      return {
        success: false,
        messageId: null,
        chatId: chatId || null,
        conference: null,
        pushSent: false,
        error: errorMessage,
      };
    }
  }
}

export default VideoConferenceService;